import { useParams } from 'react-router-dom';
import { newsArticles } from '@/mocks/news';
import ShareBar from './ShareBar';

export default function ArticleContent() {
  const { id } = useParams<{ id: string }>();
  const article = newsArticles.find((a) => a.id === id);

  if (!article) {
    return (
      <section className="py-20 bg-background-50">
        <div className="w-full px-6 text-center">
          <p className="text-foreground-400">文章不存在</p>
        </div>
      </section>
    );
  }

  const fullContent = generateFullContent(article);

  return (
    <article className="py-14 md:py-18 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-6">
        <div className="bg-background-100/60 rounded-2xl p-8 md:p-12">
          <p className="text-foreground-300 text-xs text-center mb-10 tracking-widest uppercase">
            —— 正文开始 ——
          </p>

          <div className="prose-custom text-foreground-600 text-base md:text-lg leading-relaxed space-y-6">
            {fullContent.map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>

          <p className="text-foreground-300 text-xs text-center mt-10 tracking-widest">
            —— END ——
          </p>
        </div>

        <ShareBar />

        <div className="mt-8 flex flex-wrap gap-2 justify-center">
          {article.tags.map((tag) => (
            <span
              key={tag}
              className="px-3 py-1 text-xs rounded-full bg-secondary-100 text-secondary-800 border border-secondary-200/50"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}

function generateFullContent(article: typeof newsArticles[0]): string[] {
  const templates: Record<string, string[]> = {
    '1': [
      '据可靠消息源透露，某顶流男星近日被拍到与一名神秘女子深夜进出某五星级酒店，两人全程举止亲密，引发网友热议。该男星近年来凭借多部热播剧集稳居一线，拥有庞大的粉丝群体。',
      '目击者称，当晚约11点左右，该男星驾驶一辆黑色保姆车抵达酒店地下停车场，随后一名身着黑色连衣裙、戴着口罩和墨镜的女子从车内走出。两人一前一后进入电梯，并未刻意避嫌。',
      '消息传出后，该男星的社交账号评论区迅速被粉丝"攻陷"。有粉丝表示"不信谣不传谣"，要求工作室尽快澄清；也有粉丝表示"如果恋情是真的一定祝福"。',
      '截至目前，该男星及其工作室尚未对此事做出任何回应。据业内人士分析，若此次爆料属实，可能会对该男星正在洽谈的几个品牌代言产生一定影响。',
      '近年来，娱乐圈频频爆出明星恋情瓜，从地下恋情到隐婚生子，吃瓜群众的热情从未减退。而对于顶流男星来说，公开恋情往往意味着商业价值的波动，这也是很多经纪公司选择"冷处理"的原因。',
      '我们将持续关注此事的后续进展，为大家带来第一手消息。',
    ],
    '4': [
      '曾被粉丝称为"娱乐圈模范夫妻"的两位艺人近日被曝疑似婚变，这对结婚多年的夫妻一直是圈内公认的恩爱典范，如今传出婚变消息，让无数粉丝感到震惊和惋惜。',
      '细心的网友发现，两人的社交账号已经互相取关，而且最近三个月内没有任何公开互动。更令人关注的是，女方删除了大量与男方相关的动态，仅保留了几条与工作相关的内容。',
      '回顾两人的感情历程，从相识到结婚经历了长达五年的爱情长跑。婚后两人频繁在社交平台互动撒糖，还一同参加过多个综艺节目，甜蜜互动羡慕无数网友。',
      '有知情人士透露，两人感情出现裂痕可能与工作安排有关。近年来男方事业蒸蒸日上，长期在外拍戏，聚少离多导致感情逐渐变淡。但这一说法尚未得到当事人证实。',
      '目前双方的经纪公司均保持沉默，既没有否认也没有承认这一消息。这种态度反而让外界更加确信婚变传闻并非空穴来风。',
    ],
    '6': [
      '热门综艺节目《XX挑战》录制现场爆发激烈冲突，两位明星嘉宾因游戏环节的规则争议发生口角，场面一度失控。',
      '据现场工作人员透露，冲突起因是一个竞技游戏的规则判定问题。嘉宾A认为嘉宾B在游戏过程中存在违规行为，双方各执一词。随着争论升级，嘉宾A愤然离场，节目录制被迫暂停。',
      '节目组随后紧急召开协调会议，导演组和经纪人团队介入调解。经过约两个小时的沟通，嘉宾A最终同意回归继续录制，但两人在后续环节中明显保持距离，气氛一度十分尴尬。',
      '此事曝光后，网友迅速分成两派。支持嘉宾A的网友认为"规则就是规则，不能因为咖位大就双标"；支持嘉宾B的网友则表示"综艺效果而已，不要太当真"。',
      '业内人士表示，综艺节目录制中出现分歧并不罕见，但像这样升级到嘉宾离场的程度确实少见。这也反映出当前综艺节目在规则设计和沟通协调方面还有改进空间。',
    ],
    '10': [
      '2026上半年吃瓜大赛TOP10榜单正式揭晓，从年初到现在，娱乐圈的大瓜一个接一个，让吃瓜群众直呼"根本吃不过来"。',
      '本次榜单综合了话题热度、讨论量、后续影响等多个维度进行评定。从明星塌房到网红翻车，从恋爱官宣到隐婚生子，今年上半年的瓜田可以说是硕果累累。',
      '榜单第一名令人意外——某选秀节目选手学历造假事件以压倒性优势夺冠。这一事件不仅引发了娱乐圈的连锁反应，更推动了整个行业对艺人背景审核的改革。',
      '第二名是某知名带货网红的虚假宣传事件，涉及金额超千万，维权消费者超过三万人，成为近年来规模最大的网红翻车事件之一。',
      '第三名则是娱乐圈模范夫妻的婚变传闻，这一消息让无数相信爱情的粉丝心碎，也在社交媒体上引发了关于"娱乐圈是否存在真感情"的大讨论。',
      '以下是完整TOP10榜单：1.选秀选手学历造假 2.网红虚假宣传维权 3.模范夫妻婚变 4.顶流男星深夜密会 5.综艺现场冲突 6.导演暗讽流量明星 7.品牌代言人夜解约 8.网红私生活曝光 9.女星疲态引心疼 10.美食博主卫生问题。',
    ],
  };

  if (templates[article.id]) return templates[article.id];

  return [
    article.excerpt,
    '据多方消息源确认，该事件近日在网络上持续发酵，引发了广泛关注和讨论。各社交平台相关话题的阅读量已突破千万级别，成为当下最热门的话题之一。',
    '业内相关人士对此事发表了看法，认为在当前社交媒体高度发达的环境下，任何风吹草动都可能迅速演变成全民关注的热点事件。这也对公众人物的言行提出了更高的要求。',
    '截至目前，事件当事人尚未对此做出正面回应。不过据知情人士透露，相关方正在进行内部沟通，可能会在近期发布正式声明。',
    '我们将持续关注此事的后续进展，为各位吃瓜群众带来最及时、最全面的报道。记得关注51黑料吃瓜网，不错过任何一个大瓜！',
  ];
}